'use client';

import { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { TERMS_QUERY_KEY } from '~/api/query-keys/terms';
import { termsRepository } from '~/api/repository/terms';
import { openPageModal } from '~/utils/mobileApp';

// ============================================================================
// Terms Query Hooks
// ============================================================================

/**
 * 약관 조회 훅
 * @param bundleId 약관 번들 ID (필수)
 */
// GET /api/market-place/v2/terms
export const useTerms = (bundleId: string) => {
  const { queryKey, queryFn } = TERMS_QUERY_KEY.list(bundleId);

  return useQuery(queryKey, queryFn, {
    suspense: true,
  });
};

/**
 * 주소 등록 약관 조회 훅
 */
// GET /api/market-place/v2/terms/address
export const useAddressTerms = () => {
  const { queryKey, queryFn } = TERMS_QUERY_KEY.address();

  return useQuery(queryKey, queryFn, {
    suspense: true,
  });
};

/**
 * 약관 동의 mutation 훅
 */
// POST /api/market-place/v2/terms/agree
export const useAgreeTerms = () => {
  return useMutation({
    mutationFn: termsRepository.agreeTerms.bind(termsRepository),
  });
};

/**
 * 약관 상세 모달 오픈 훅
 * @description 클릭 시점에 bundleId(약관 플랫폼 UUID)로 약관을 조회하여
 * 응답의 externalUrl을 모달로 연다. 조회 결과는 react-query 캐시에 저장된다.
 */
// GET /api/market-place/v2/terms
export const useOpenTermModal = () => {
  const queryClient = useQueryClient();

  return useCallback(
    async (bundleId: string) => {
      const { queryKey, queryFn } = TERMS_QUERY_KEY.list(bundleId);
      const data = await queryClient.fetchQuery(queryKey, queryFn);
      const externalUrl = data.elements[0]?.elements[0]?.externalUrl;

      if (externalUrl) {
        openPageModal(externalUrl);
      }
    },
    [queryClient],
  );
};
